import React from 'react';

const DetailEl = ({field, label, item}) => {
    return <p><b>{label}:</b> {item[field]}</p>;
};

export default DetailEl;